import { Button, Flex, Input } from "antd";
import to from "await-to-js";
import { t } from "i18next";
import { useContext, useEffect, useState } from "react";

import { Table } from "../../../../components/Table/Table";
import { ModalsContext } from "../../../../context/modals.context";
import { CentralRegistryContext } from "../../../../modules/ministry/centralRegistry/centralRegistry.context";
import { centralRegistryService } from "../../../../modules/ministry/centralRegistry/centralRegistry.service";
import { EvidencionaListaMaloprodajnihObjekataProps } from "../../../../modules/ministry/centralRegistry/centralRegistry.types";
import style from "../CentralRegistry.module.scss";

const INITIAL_PARAMS = () => ({
  pib: null,
  brojDozvole: null,
});

export const MerchantRegistrationList = () => {
  const { centralRegistry, setCentralRegistry } = useContext(
    CentralRegistryContext
  );
  const { setError } = useContext(ModalsContext);
  const [params, setParams] = useState(INITIAL_PARAMS());

  const postEvidencionaListaMaloprodajnihObjekata = async () => {
    const [err, res] = await to(
      centralRegistryService.postEvidencionaListaMaloprodajnihObjekata(params)
    );
    if (err || !res.success) return setError(res?.errorMessage);
    setCentralRegistry({ merchantRegistrationTable: res.data });
  };

  const updateParams = (
    accessor: keyof EvidencionaListaMaloprodajnihObjekataProps,
    value: string | null
  ) => {
    setParams({ ...params, [accessor]: value });
  };

  useEffect(() => {
    postEvidencionaListaMaloprodajnihObjekata();
  }, []);

  const colDef = [
    {
      title: t("TABLES.BROJ_RESENJA"),
      dataIndex: "brojDozvole",
      width: "120px",
    },
    {
      title: t("TABLES.DATUM_OD_KADA_VAZI_RESENJE"),
      dataIndex: "datumVazenjaDozvoleOd",
      width: "230px",
    },
    {
      title: t("TABLES.DATUM_IZADAVANJA"),
      dataIndex: "datumIzdavanjaDozvole",
      width: "160px",
    },
    {
      title: t("TABLES.NACIN_ORGANIZOVANJA"),
      dataIndex: "nacinOrganizovanja",
      width: "130px",
    },
    {
      title: t("TABLES.NAZIV_PRIVREDNOG_SUBJEKTA"),
      dataIndex: "nazivPrivrednogSubjekta",
      width: "210px",
    },
    {
      title: t("COMMON.PIB"),
      dataIndex: "pib",
      width: "120px",
    },
    {
      title: t("TABLES.NAZIV_MALOPRODAJNOG_OBJEKTA"),
      dataIndex: "nazivMaloprodajnogObjekta",
      width: "120px",
    },
    {
      title: t("TABLES.ADRESA_MALOPRODAJNOG_OBJEKTA"),
      dataIndex: "adresaMaloprodajnogObjekta",
      width: "190px",
    },
  ];

  return (
    <div className={style.mainContainer}>
      <div id="merchant_registration_list">
        <h2>{t("NAVIGATION.EVIDENCIONA_LISTA_TRGOVCIMA_CELO")}</h2>
        <Flex className={style.buttonContainer2} gap={12}>
          <Input
            name="pib"
            allowClear
            className="w-49"
            placeholder={t("PLACEHOLDERS.PIB")}
            onChange={({ target }) => updateParams("pib", target.value)}
          />
          <Input
            name="brojDozvole"
            allowClear
            className="w-49"
            placeholder={t("PLACEHOLDERS.BROJ_RESENJA")}
            onChange={({ target }) => updateParams("brojDozvole", target.value)}
          />
          <Button
            type="primary"
            onClick={postEvidencionaListaMaloprodajnihObjekata}
          >
            {t("COMMON.PRETRAZI")}
          </Button>
        </Flex>
      </div>
      <Table
        columns={colDef}
        scrollConfig={["#merchant_registration_list"]}
        dataSource={centralRegistry.merchantRegistrationTable}
        name="merchant-registraiton-list-table"
      />
    </div>
  );
};
